module.exports = __webpack_public_path__ + "img/popup-game-sucai.dfa348c3.png";